import React, { Component, useEffect, useState, useRef } from "react";
import DialCode from './PaymentDetails/DialCode';
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from 'react-cookie';
import { setCustomerAgentLogin, getGeoInfo, registrationagentemailcheck } from './axios';
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import "./AgentSignup.css";

export default function AgentSignupCompleted() {

    return (
      <div id="login">
            <figure> <a href="/">
              <img src="images/logo/seyLogo.png" alt="Holiday Seychelles" className="logo_sticky" />
              </a>
            </figure> <br/>
            <div style={{textAlign: 'center', width: '700px', margin: 'auto'}}>
              <h3 style={{marginBottom: '3%'}}>Thank You for registering with us</h3>
            <p style={{fontSize: '16px', fontWeight: '500'}}>We have sent an email with a verification link to your email address. In order to complete the sign-up process, please click the verification link.</p>
            <p style={{fontSize: '16px', fontWeight: '500'}}>Your account will be activated with 24 hours after the verification. You will receive a mail on your registered email address once your account is activated.</p>
            <p style={{fontSize: '16px', fontWeight: '500'}}>In case, if you do not receive any communication from our side.</p> 
            <p style={{fontSize: '16px', fontWeight: '500'}}><b>call us at</b>  <a href="tel://2484376668"><i class="fa fa-phone" aria-hidden="true"></i> +248 437 6666</a> or <b>email to us</b> on   <a href="#"><i class="fa fa-envelope-o" aria-hidden="true"></i> info@holidays-seychelles.com</a></p>
        <div class="btn btn-primary" style={{color: '#fff',
    backgroundColor: '#ed9853',
    borderColor: '#ec8c51',
    cursor: 'pointer', marginTop: '30px'}}><strong><a href="/" style={{color:'#fff'}}>Back To Home</a></strong></div>
 </div>
          
    
  </div>
        );
   
}